export const FORM_ATTRIBUTE_TYPES = [
  { label: "Short Answer", value: "short" },
  { label: "Long Answer", value: "long" },
  { label: "Multiple-Choice", value: "choice" },
  { label: "Select", value: "select" },
  { label: "File Upload", value: "upload" },
  { label: "Text", value: "text" },
];
